import tradeData from '../data/map-trade.json';

const excludedImplicits = [
	'implicit.stat_1792283443|1', 'implicit.stat_1792283443|2',
	'implicit.stat_2563183002|1', 'implicit.stat_2563183002|2',
	'implicit.stat_2563183002|3', 'implicit.stat_2563183002|4',
	'implicit.stat_2696470877',
];
const mapNumbers = { itemQuantity: 'map_iiq', itemRarity: 'map_iir', packSize: 'map_packsize' };
const dropNumbers = {
	mapDrop: 'pseudo.pseudo_map_more_map_drops',
	scarab: 'pseudo.pseudo_map_more_scarab_drops',
	currency: 'pseudo.pseudo_map_more_currency_drops',
	divination: 'pseudo.pseudo_map_more_card_drops',
};

function minimum(value, field) {
	if (value === '' || value === undefined || value === null) return undefined;

	if ((typeof value !== 'string' && typeof value !== 'number') ||
		!/^\d+(?:\.\d+)?$/.test(String(value)) || !Number.isFinite(Number(value))) {
		throw new Error(`${field} 必須是有限的非負數值`);
	}

	return { min: Number(value) };
}

function mapped(selection, data) {
	if (!selection || typeof selection.mod !== 'string' || typeof selection.isT17 !== 'boolean') {
		throw new Error('詞綴選擇格式不正確，請重新選取');
	}

	const row = data[selection.isT17 ? 't17' : 'normal'][selection.mod];

	if (!row || row.blocked || !row.filters?.length) {
		throw new Error(`無法交易搜尋「${selection.mod}」：${row?.blocked || '尚未建立交易對照'}`);
	}

	if (!['any', 'all'].includes(row.relation)) throw new Error(`「${selection.mod}」的交易對照格式不正確`);
	return row;
}

export function buildMapTradeQuery(settings, data = tradeData) {
	if (data.blocked) throw new Error(data.blocked);

	const { wantedMods = [], unwantedMods = [], allGoodMods = false, corrupted = false, rarity = [] } = settings;

	if (!Array.isArray(wantedMods) || !Array.isArray(unwantedMods) || !Array.isArray(rarity) ||
		typeof allGoodMods !== 'boolean' || typeof corrupted !== 'boolean') throw new Error('交易篩選格式不正確');

	const rarities = [...new Set(rarity)];

	if (rarities.some(value => !['normal', 'magic', 'rare'].includes(value))) throw new Error('無效的物品稀有度');
	if (rarities.length === 2) throw new Error('交易市集目前不支援同時選取兩種稀有度，請選一種或全部');

	const wanted = wantedMods.map(mod => mapped(mod, data));
	const unwanted = unwantedMods.map(mod => mapped(mod, data));
	const stats = [];

	for (const row of unwanted) {
		if (row.relation === 'all' && row.filters.length > 1) {
			throw new Error('排除的複合詞綴尚未確認交易語意，請取消該詞綴後再試');
		}
	}

	if (unwanted.length) stats.push({ type: 'not', filters: unwanted.flatMap(row => row.filters) });
	stats.push({ type: 'not', filters: excludedImplicits.map(id => ({ id })) });

	if (allGoodMods) {
		for (const row of wanted) {
			stats.push(row.relation === 'any' && row.filters.length > 1
				? { type: 'count', value: { min: 1 }, filters: row.filters }
				: { type: 'and', filters: row.filters });
		}
	} else if (wanted.length) {
		if (wanted.some(row => row.relation === 'all' && row.filters.length > 1)) {
			throw new Error('複合詞綴不支援「任一符合」交易搜尋，請改用全部符合');
		}

		stats.push({ type: 'count', value: { min: 1 }, filters: wanted.flatMap(row => row.filters) });
	}

	const mapFilters = {
		map_tier: { min: 16 }, map_blighted: { option: 'false' }, map_uberblighted: { option: 'false' },
	};

	for (const [field, id] of Object.entries(mapNumbers)) {
		const value = minimum(settings[field], field);

		if (value) mapFilters[id] = value;
	}

	const drops = [];

	for (const [field, id] of Object.entries(dropNumbers)) {
		const value = minimum(settings[field], field);

		if (value) drops.push({ id, value });
	}

	if (drops.length) stats.push({ type: 'and', filters: drops });
	return {
		query: {
			status: { option: 'securable' }, stats,
			filters: {
				map_filters: { filters: mapFilters },
				type_filters: { filters: { category: { option: 'map' }, rarity: { option: rarities.length === 1 ? rarities[0] : 'nonunique' } } },
				misc_filters: { filters: { foil_variation: { option: 'none' }, ...(corrupted ? { corrupted: { option: 'true' } } : {}) } },
			},
		},
		sort: { price: 'asc' },
	};
}

export default function generateMapTradeUrl(settings, league, data = tradeData) {
	if (!data.leagues.some(item => item.id === league)) throw new Error('請選擇有效的台服聯盟');
	return `https://pathofexile.tw/trade/search/${encodeURIComponent(league)}?q=${encodeURIComponent(JSON.stringify(buildMapTradeQuery(settings, data)))}`;
}
